import React from 'react'

export const getTransformedLabel = material => {
  const { color, ornament } = material
  let label

  switch (material.color_type) {
    case 'ral' :
      label = 'RAL ' + color.split(' ')[0]
      break
    case 'anodized' :
      label = color.split('_')[1]
      label = label[0].toUpperCase() + label.substring(1)
      break
    case 'decor' :
      label = ornament
      break
    default :
      break
  }

  return label
}

const ColorPicker = ({ colors, activeLayer, hideLabel, className, onClick }) => (
  <div className={className}>
    {colors.map(color => {
      let classes = ['configurator-color-picker', 'aluk-activable']

      if (color.image_file === activeLayer) {
        classes.push('active')
      }

      if (color.declinable) classes.push('declinable')

      return (
        <button
          key={color.image_file + color.customDesign}
          className={classes.join(' ')}
          style={color.css}
          onClick={onClick}
          value={JSON.stringify(color)}
        ><span>{!hideLabel && getTransformedLabel(color)}</span></button>
      )
    })}
  </div>
)

export default ColorPicker



// WEBPACK FOOTER //
// ./src/components/ColorPicker.js